module.exports = __webpack_public_path__ + "img/Check-icon.29eb13e5.svg";